import * as React from "react";
import { useCallback } from "react";
import usePermissions from "hooks/usePermissions";
import useHistory from "routing/useHistory";
import { STEP_READABLE_ACTION_TYPES } from "security-app/components/SecurityEvents/EventProcedures/plugin/StepList/StepActionsButton";
import StepActionButton from "./StepActionButton";
function StepPerformSearch({ config, actionUrl }) {
  const { saved_search } = config;
  const { isPermitted } = usePermissions();
  const disabled = saved_search && !isPermitted(`view:read:${saved_search}`);
  const history = useHistory();
  const handleClick = useCallback(() => history.push(actionUrl), [history, actionUrl]);
  return /* @__PURE__ */ React.createElement(
    StepActionButton,
    {
      hint: disabled ? "You don't have access to see this saved search" : void 0,
      title: STEP_READABLE_ACTION_TYPES.perform_search,
      onClick: disabled ? void 0 : handleClick,
      disabled
    }
  );
}
export default StepPerformSearch;
